import {
    AlertTypes,
    apiClient,
    GenericFormContainer,
    IAlertData,
    Leap4Breadcrumbs,
    Mode,
    Spinner,
    Toc,
} from "@leap4/frontend";
import {useHistory, useParams} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {RootState} from "../../../../store/store";
import {connect, ConnectedProps, useDispatch} from "react-redux";
import {urlService} from "../../../routing/urlsService";
import {DetailsForm} from "../DetailsForm";
import {UsersBaseUrl} from "../../../../config/generals";
import {EditUserStore} from "./EditUserStrore";
import {initialUserObj} from "../User";
import {UsersContext} from "../UserContext";
import {updateUserId} from "../../../../actions/users";
import {setAlert} from "../../../../actions/alert";

const mapStateToProps = (state: RootState) => ({
    users: state.alert
});

const mapDispatch = {
    setAlert
};

export interface IUser {
    _id: string;
    name: string;
    email: string;
    metadataMulti: string[];
}

export interface IEditGroupProps extends PropsFromRedux{
    setGroup: (data: IAlertData) => void;
    setAlert: any;
}


const connector = connect(mapStateToProps, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
let editUserStore: EditUserStore

const _editUser = (props: IEditGroupProps) => {
    const {setGroup, setAlert} = props;
    const params = useParams<{ id?: string }>();
    const history = useHistory();
    const dispatch = useDispatch();
    const [user, setUser] = useState<IUser>(initialUserObj);
    const UserContextValue = useMemo(() => ({user, setUser}), [user]);
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)

    const onSubmit = async () => {
        setIsLoading(true)
        await updateUserId(dispatch, user._id, user.metadataMulti)
        setIsLoading(false)
        setAlert("User updated successfully", AlertTypes.SUCCESS);
        history.push(urlService.editUsers(user._id));
    };

    const fetchData = async (id: string) => {
        editUserStore = await new EditUserStore({
                setIsLoading,
                setIsLoadError,
                setItem: setUser,
                axiosClient: apiClient,
                alertFunc: setGroup,
                baseUrl: `${UsersBaseUrl}`
            }
        )
        return await editUserStore.refreshItem(id);
    }

    useEffect(() => {
        if (!params.id) {
            return;
        }
        fetchData(params.id)

    }, [params.id])

    if (isLoadError) {
        return (<>Error Loading the page</>);
    }
    if (isLoading) {
        return (<Spinner/>);
    }
    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[
                {
                    text: "Users Dashboard",
                    link: urlService.users(),
                    icon: <Toc/>
                },
                {
                text: user.name,
                link: urlService.users() + "/" + user._id,
                icon: <Toc/>
            },
            ]}
            />
            <GenericFormContainer mode={Mode.Edit} onCreateOrEditFunc={onSubmit} buttonsProps={{delete: {"disabled": true}}}>
                <UsersContext.Provider value={UserContextValue}>
                    <DetailsForm />
                </UsersContext.Provider>
            </GenericFormContainer>
        </>
    )
}

const editUser = connect(mapStateToProps, {
    setAlert
})(_editUser);

export {editUser}
